import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)
Vue.http.options.root = process.env.API_URI

let _instance = null

export default class BaseService {
  /**
   * Create new instance BaseService
   */
  constructor () {
    if (!_instance) {
      _instance = this
    }
    this._http = Vue.http
  }

  /**
   * @param {string} url
   * @param {object} data
   * @param {string} method
   * @returns {*}
   */
  execute (url, data = {}, method = 'get') {
    return this[method](url, data)
  }

  /**
   * @param {string} url
   * @param {object} data
   * @returns {PromiseLike<HttpResponse>}
   */
  get (url, data) {
    const defaultData = { body: 'json' }
    return this._http.get(url, Object.assign(defaultData, data))
      .then(response => {
        if (response.body.code === 404) {
          return null
        } else if (response.body.code !== 0) {
          throw Error(response.body.error)
        }
        return response.body.data
      })
  }
}



// WEBPACK FOOTER //
// ./src/service/BaseService.js